import request from "superagent";
import { getAuthHeader } from "../utils/superagent";
import { handleApiError } from "src/utils/errors";
import { showErrorToast } from "@src/appV2/lib/Notifications";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";

export interface FacilityCategoryNote {
  categoryId: string;
  category: string;
  description: string;
  sortOrder: number;
  hideInput: boolean;
  noteId: string;
  note: string;
  identifier: string;
  updatedBy: string;
  updatedAt: string;
}

export async function fetchAllNotes(
  workplaceId: string,
  options?: { includeConfig: boolean }
): Promise<FacilityCategoryNote[]> {
  return await request
    .get(`${global.api}/facilityNoteCategory/get-notes/${workplaceId}`)
    .query(options?.includeConfig ? { includeConfig: true } : {})
    .set(await getAuthHeader())
    .then((res) => res.body);
}

interface UpdatedFacilityCategoryNote {
  categoryId: string;
  note: string;
  updatedAt: string;
  updatedBy: string;
  _id: string;
}
export const updateNotes = async (
  workplaceId: string,
  data: Partial<FacilityCategoryNote>
): Promise<UpdatedFacilityCategoryNote> => {
  return await request
    .patch(`${global.api}/facilityNoteCategory/update-note/${workplaceId}`)
    .set(await getAuthHeader())
    .send(data)
    .then((res) => res.body);
};

export const getFacilityDetails = async (hcfIds, projection) => {
  try {
    const res = await request
      .get(`${global.api}/facilityprofile/details`)
      .set(await getAuthHeader())
      .query({ facilityIds: hcfIds, projection });
    return res.body;
    // FIXME: Automatically disabled during ESLint config update
  } catch {
    showErrorToast("Error while fetching workplace details");
    return [];
  }
};

export const updateFacilityProfile = async (data) => {
  return request
    .put(`${global.api}/facilityprofile/put`)
    .set(await getAuthHeader())
    .send(data)
    .catch((error) => {
      logError(APP_V2_APP_EVENTS.UPDATE_FACILITY_PROFILE_REJECTED, {
        error,
        metadata: { facilityId: data?.facilityId },
      });
      handleApiError(error);
    });
};

export const fetchAllHolidays = async () => {
  try {
    const { body } = await request.get(`${global.api}/holidays`).set(await getAuthHeader());
    return body.map((h) => ({ id: h._id, name: h.name }));
    // FIXME: Automatically disabled during ESLint config update
  } catch {
    return [];
  }
};

export type FacilityOnboardingStep = {
  postShifts: boolean;
  getMobileApp: boolean;
  checkInstructions: boolean;
  addTeamMembers: boolean;
  takeProductTour: boolean;
  stage: "pending" | "started" | "completed" | "overdue";
  startedAt?: Date;
  hasSentWorkerInvitations: boolean;
};

export const getFacilityOnboardingSteps = async (
  workplaceId: string,
  workplaceUserId: string
): Promise<FacilityOnboardingStep> => {
  const response = await request
    .get(`${global.api}/facility-onboarding/facilities/${workplaceId}/users/${workplaceUserId}`)
    .set(await getAuthHeader())
    .send();
  return response.body;
};

export const updateFacilityOnboardingSteps = async (
  workplaceId: string,
  onboardingSteps: Partial<FacilityOnboardingStep>,
  workplaceUserId: string
): Promise<FacilityOnboardingStep> => {
  const response = await request
    .put(`${global.api}/facility-onboarding/facilities/${workplaceId}/users/${workplaceUserId}`)
    .set(await getAuthHeader())
    .send(onboardingSteps);
  return response.body;
};

export const updateEarlyClockInEnabledInsideFacility = async (
  facilityId: string,
  isEarlyClockInEnabled: boolean
): Promise<string> => {
  return request
    .put(`${global.api}/facilityprofile/${facilityId}/update-early-clock-in-enabled`)
    .set(await getAuthHeader())
    .send({ isEarlyClockInEnabled })
    .then((res) => res.body);
};
